module.exports = __webpack_public_path__ + "static/media/lamp.cb4bbd12.png";